import { Amplify } from 'aws-amplify';
import { LD_FLAG, LDPlugin } from 'launchdarkly-vue-client-sdk';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { awsConfig } from '@/aws-exports.ts';
import { setLDFlagKey } from '@/composables/use-ld-flag.ts';
import { NotivuePlugin } from '@/plugins/notivue.ts';
import App from './App.vue';
import { VersionPlugin } from './plugins/version.ts';
import router from './router/routes.ts';
import './assets/main.css';

/* ---------------------------------------------------------------------------------------------- */

/*
 * Configure AWS Amplify for cognito authentication
 */
Amplify.configure(awsConfig);

/* ---------------------------------------------------------------------------------------------- */

/*
 * Creates a new vue app instance
 */
const app = createApp(App);

/*
 * Initialize app with pinia and routers
 */
app.use(createPinia());
app.use(router);

/**
 * Register custom plugins
 */
app.use(VersionPlugin);
app.use(NotivuePlugin); // notivue toast

// Start with an anonymous context; will be updated to user-specific after authentication
// via useLaunchDarklyContext composable in App.vue
const context = {
   kind: 'user',
   anonymous: true,
};

const clientSideID = import.meta.env.VITE_LD_CLIENT_ID ?? '';
if (!clientSideID) {
   console.warn('VITE_LD_CLIENT_ID is not set. LaunchDarkly will not initialize properly.');
}
setLDFlagKey(LD_FLAG);
app.use(LDPlugin, {
   clientSideID,
   context,
});

app.mount('#app');
